import { IoFunnelOutline } from "react-icons/io5";
import { IconButton } from "../common";

const FunnelIconButton = ({
    onClick,
    active,
    className,
}: {
    onClick: () => void;
    active?: boolean;
    className?: string;
}) => {
    const handleClick = () => {
        onClick();
    };
    return (
        <div
            className="relative cursor-pointer rounded-lg border bg-white"
            onClick={handleClick}
        >
            <IconButton
                icon={<IoFunnelOutline className="h-4 w-4 2xl:h-5 2xl:w-5" />}
                onClick={handleClick}
                className={className}
            />
            {active && (
                <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-green-500" />
            )}
        </div>
    );
};

export { FunnelIconButton };



